import React, { Component } from 'react';
import { Checkbox } from 'antd';
import { CUSTOMER_CODE } from '../../../../common/utils/static-data';

export class UserType extends Component {

  onChange = (value)=>{
    const { validate, onChange, onChangeFormValues, setEnterprise } = this.props;
    setEnterprise(value === CUSTOMER_CODE.enterprise)
    if (value !== this.props.value && value === CUSTOMER_CODE.personal){
      onChangeFormValues({
        tax_code: '',
        bank_account_holder: '',
        bank_name: '',
        bank_account_number: '',
        users: []
      });
    }
    onChange(value);
    validate();
  }
  render() {
    const { value, disabled }= this.props;
    return (
      <div className="vat-fee">
        <Checkbox disabled={disabled} checked={value === CUSTOMER_CODE.enterprise} onChange={() => this.onChange(CUSTOMER_CODE.enterprise)}>Doanh nghiệp</Checkbox>
        <Checkbox disabled={disabled} checked={value === CUSTOMER_CODE.personal} onChange={() => this.onChange(CUSTOMER_CODE.personal)}>Cá nhân</Checkbox>
      </div>
    )
  }
}
